
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-openings/[slug]",
      function () {
        return require("private-next-pages/job-openings/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-openings/[slug]"])
      });
    }
  